import http from '@/utils/http'

export function fetchBranch(params) {
	return http.get("/api/public/weixin/branchs", {
		params: params
	});
}

